module.exports = __webpack_public_path__ + "img/vanguard.c950afd9.png";